/**
 * Copyright © 2022 Anagog Ltd. All rights reserved.
 */

export enum JEMAUserInteractionEventTriggerType {
	acceptedTrigger       = "TRIGGERED",
	notificationDismissed = "DISMISSED",
	notificationClick     = "CLICKED",
	notificationTimeout   = "TIMEOUT",
	conversion            = "CONVERSION"
}